import React, { Component } from "react"
import { Button } from "@material-ui/core"
import { Link } from "react-router-dom"

import ScheduleTable from "../../../components/Table/ScheduleTable"
import SectionHeader from "../../../components/SectionHeader"
import rebase from "../../../config/rebase"
import { dbPrefix, knowledgeAreaArray } from "../../../Constants"
import Wrapper from "../../../components/Common/Wrapper"

class Papers extends Component {

  state = {
    learnMoredialog: false,
    getStartedDialog: false,
    papers: []
  }

  columns = [
    {
      name: "paperTitle",
      label: "Nome",
      options: {
        filter: false
      }
    },
    {
      name: "knowledgeArea",
      label: "Área de Conhecimento",
      options: {
        customBodyRender: (val) => {
          const area = knowledgeAreaArray.find(k => val === k.value)
          return <span>{area.title}</span>
        }
      }
    },
    {
      name: "Visualizar",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (index) => {
          return (
            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              component={Link}
              to={"/avaliador/ver-paper/" + this.state.papers[index].key}>
              &#8594;
            </Button>
          )
        }
      }
    }

  ];

  componentDidMount() {
    rebase.fetch(dbPrefix + 'papers', {
      context: this,
      asArray: true,
      queries: {
        orderByChild: 'knowledgeArea',
        equalTo: this.props.user.knowledgeArea
      }
    }).then(data => {
      this.setState({ papers: data })
    }).catch(error => {
      console.log(error)
      this.setState({ fatalError: 'Ocorreu um erro' })
    }).finally(() => {
      this.setState({ loaded: true })
    })
  }

  render() {

    return (
      <Wrapper loaded={this.state.loaded} fatalError={this.state.fatalError} currentPath={this.props.location.pathname} evaluatorTopbar>

        <SectionHeader
          title="Trabalhos"
          subtitle="A tabelas abaixo lista todos os trabalhos"
        />
        <ScheduleTable data={this.state.papers} columns={this.columns} title={"Trabalhos Cadastrados"} />
      </Wrapper>
    )
  }
}

export default Papers
